<template>
  <div id="company-health-status" class="page-container">
    <div class="page-content">
      <div class="flex-mid">
        <div class="box" style="display: flex; justify-content: center; align-items: center;">
          <div v-if="loading && loadingAward" class="flex-mid"><loading-even></loading-even></div>

          <div v-else>
            <div class="flex-row mb-16" style="justify-content: flex-end;">
              <a href="https://happily.ai" target="_blank">
                <img style="height: 52px;" src="@/assets/images/company-health-status/logo_blue_52.png" />
              </a>
            </div>
            <div class="flex-row-between">
              <div class="flex-row">
                <span class="fs-18 fw-900">{{ company_name.toUpperCase() }} HEALTH STATUS</span>
                <div>
                  <span class="fs-11 fw-700 fc-6C30CC ml-32 pt-8 pb-8 pr-12 pl-12"
                    style="background-color:#f1f1f1; border-radius: 2px;">
                    <span class="dot"></span>Updated 30 minutes ago</span>
                </div>
              </div>
              <div class="fs-13" style="color:#b2b2b2;"> Benchmarked against other companies globally</div>
            </div>
            <div class="fs-15 fw-700" style="margin-top: 46px;"> Company Metrics</div>
            <div class="box-shadow" style="min-height: 96px;padding: 16px; margin-top: 8px;">
              <div class="flex-column" style="margin-top: 8px;">
                <span class="fs-13 fw-600">Happiness Rate</span>
                <div class="mt-6">
                  <div class="bar-contariner flex-center">
                    <div v-for="index in (90 - happyStatus.length)" :key="index + '_bar'" class="bar"></div>
                    <div v-for="(value, index) in arrayToPercentage(happyStatus)" :key="index + '_bar_adoption'"
                      :class="`bar ${value}`"></div>

                    <div class="fs-16 fw-700 ml-6">{{ happyStatuspercent }}%</div>
                  </div>
                </div>
                <div class="flex-row mt-19">
                  <div class="fs-12 mr-15" style="color:#b2b2b2">90 days ago</div>
                  <div style="border-top: solid;width:730px;border-color: #b2b2b2;margin-top:6px; "></div>
                  <div class="fs-12 ml-15" style="color:#b2b2b2">Today</div>
                </div>
              </div>

            </div>

            <div class="grid-3-33 mt-24">
              <div class="box-shadow" style="height:86px;padding: 16px;">
                <div class="flex-row-between">
                  <span class="fs-13 fw-700">Open Feedback Rate</span>
                  <div class="fs-11 fw-700" style="color:#b2b2b2; width: 90px; text-align: center;">
                    {{ percentileRank.feedback > 50 ? `Top ${100 - percentileRank.feedback}%` : `Bottom
                    ${percentileRank.feedback}%` }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="mt-6">
                    <div class="bar-contariner flex-center">
                      <div v-for="(value, index) in arrayToPercentage_ten(feedback.openEndedFeedback, 'feedback')"
                        :key="index + '_bar_feedback'" :class="`bar ${value}`"></div>
                      <div class="fs-16 fw-700 ml-12">{{ (feedback.openEndedFeedback) }}%</div>
                      <div class="fs-11"
                        :style="`color: ${feedback.compare > 0 ? '#35d077' : feedback.compare < 0 ? '#f44336' : '#777777'}; padding-left: 4px;`">
                        {{ feedback.compare !== 0 ? (feedback.compare > 0 ? `+${feedback.compare}` : feedback.compare) :
            '+0' }}% </div>
                    </div>
                  </div>
                  <div style="width:70px;height:32px;margin-left: 50px;">
                    <img style="width: 64px;height: 32px;" :src="getCurve(percentileRank.feedback)" />
                  </div>

                </div>
                <div class="fs-12 fw-700" style="margin-top: 12px;color:#b2b2b2;">Openness and willingness of employees
                  to share feedback with the organization</div>


              </div>
              <div class="box-shadow" style="height:86px;padding: 16px;">
                <div class="flex-row-between">
                  <span class="fs-13 fw-700">Recognition Participation</span>
                  <div class="fs-11 fw-700" style="color:#b2b2b2; width: 86px; text-align: center;">
                    {{ percentileRank.participationRate > 50 ? `Top ${100 - percentileRank.participationRate}%` :
            `Bottom ${percentileRank.participationRate}%` }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="mt-6">
                    <div class="bar-contariner flex-center">
                      <div
                        v-for="(value, index) in arrayToPercentage_ten(participationRate.participationRate, 'participationRate')"
                        :key="index + '_bar_feedback'" :class="`bar ${value}`"></div>
                      <div class="fs-16 fw-700 ml-12">{{ participationRate.participationRate }}%</div>
                      <div class="fs-11"
                        :style="`color: ${participationRate.compare > 0 ? '#35d077' : participationRate.compare < 0 ? '#f44336' : '#777777'}; padding-left: 4px;`">
                        {{ participationRate.compare !== 0 ? (participationRate.compare > 0 ?
            `+${participationRate.compare}` : participationRate.compare) : '+0' }}% </div>
                    </div>
                  </div>
                  <div style="width:70px;height:32px;align-content: end;margin-left:50px;">
                    <img style="width: 64px;height: 32px;" :src="getCurve(percentileRank.participationRate)" />
                  </div>

                </div>
                <div class="fs-12 fw-700" style="margin-top: 12px;color:#b2b2b2;">Team members who take the effort to
                  recognize the positive efforts of others</div>


              </div>
              <div class="box-shadow" style="height:86px;padding: 16px;">
                <div class="flex-row-between">
                  <span class="fs-13 fw-700">Manager Responsiveness</span>
                  <div class="fs-11 fw-700" style="color:#b2b2b2; width: 106px; text-align: center;">
                    {{ percentileRank.managerRate > 50 ? `Top ${100 - percentileRank.managerRate}%` : `Bottom
                    ${percentileRank.managerRate}%` }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="mt-6">
                    <div class="bar-contariner flex-center">
                      <div v-for="(value, index) in arrayToPercentage_ten(managerRate.managerRate, 'manager_activity')"
                        :key="index + '_bar_feedback'" :class="`bar ${value}`"></div>
                      <div class="fs-16 fw-700 ml-6">{{ managerRate.managerRate }}%</div>
                      <div class="fs-11"
                        :style="`color: ${managerRate.compare > 0 ? '#35d077' : managerRate.compare < 0 ? '#f44336' : '#777777'}; padding-left: 4px;`">
                        {{ managerRate.compare !== 0 ? (managerRate.compare > 0 ? `+${managerRate.compare}` :
            managerRate.compare) : '+0' }}% </div>
                    </div>
                  </div>
                  <div style="width:70px;height:32px;align-content: end;margin-left: 50px;">
                    <img style="width: 64px;height: 32px;" :src="getCurve(percentileRank.managerRate)" />
                  </div>

                </div>
                <div class="fs-12 fw-700" style="margin-top: 12px;color:#b2b2b2;">The responsiveness of our managers to
                  reply to feedback shared</div>

              </div>
            </div>


            <div class="mt-24 fs-15 fw-700">Awards</div>
            <div class="box-shadow mt-8" style="min-height: 198px;">
              <div class="flex-between pt-16 awards" style="padding-left:150px;padding-right: 150px;">
                <div class="center" style="width: 25%;">
                  <img :style="getImageAwardstyle('feedback')" :src="getImageAward('feedback')" />
                  <div :style="getAwardTextStyle('feedback')">
                    <div class="title fs-11 fw-600" style="margin-top: -16px;">Feedback</div>
                    <div class="description fs-11 mt-4 pl-6 pr-6">High open-ended feedback rates fostering continuous
                      improvement</div>
                  </div>
                </div>
                <div class="center" style="width: 25%;"><img :style="getImageAwardstyle('WHO_5')" :src="getImageAward('WHO_5')" />
                  <div :style="getAwardTextStyle('WHO_5')">
                    <div class="title fs-11 fw-600" style="margin-top: -16px;">Well-being</div>
                    <div class="description fs-11 mt-4 pl-6 pr-6">Exceptional employee well-being, surpassing WHO-5
                      index
                      benchmarks</div>
                  </div>
                </div>
                <div class="center" style="width: 25%;"><img :style="getImageAwardstyle('participation')"
                    :src="getImageAward('participation')" />
                  <div :style="getAwardTextStyle('participation')">
                    <div class="title fs-11 fw-600" style="margin-top: -16px;">Recognition</div>
                    <div class="description fs-11 mt-4 pl-6 pr-6">Strong peer-to-peer recognition culture promoting
                      mutual
                      support</div>
                  </div>
                </div>
                <div class="center" style="width: 25%;"><img :style="getImageAwardstyle('eNPS')" :src="getImageAward('eNPS')" />
                  <div :style="getAwardTextStyle('eNPS')">
                    <div class="title fs-11 fw-600" style="margin-top: -16px;">Employee Satisfaction</div>
                    <div class="description fs-11 mt-4 pl-6 pr-6">Outstanding workplace experience with high
                      satisfaction
                      and engagement</div>
                  </div>
                </div>
                <!-- <div class="center"><img :style="getImageAwardstyle('NPS')"
                    :src="getImageAward('NPS')" />
                    <div :style="getAwardTextStyle('NPS')">
                  <div class="title fs-11 fw-600" style="margin-top: -16px;">Brand Advocacy</div>
                  <div class="description fs-11 mt-4 pl-6 pr-6">Employees as passionate ambassadors, championing company
                    products/services</div>
                  </div>
                </div> -->
              </div>

              <div class="flex-between pt-16 pb-32 awards" style="padding-left:25%;padding-right: 25%;">
                <div class="center" style="width: 30%;"><img :style="getImageAwardstyle('NPS')" :src="getImageAward('NPS')" />
                  <div :style="getAwardTextStyle('NPS')">
                    <div class="title fs-11 fw-600" style="margin-top: -16px;">Brand Advocacy</div>
                    <div class="description fs-11 mt-4 pl-6 pr-6">Employees as passionate ambassadors, championing
                      company
                      products/services</div>
                  </div>
                </div>
                <div class="center" style="width: 30%;"><img :style="getImageAwardstyle('debi')" :src="getImageAward('debi')" />
                  <div :style="getAwardTextStyle('debi')">
                    <div class="title fs-11 fw-600" style="margin-top: -16px;">Engagement Excellence</div>
                    <div class="description fs-11 mt-4 pl-6 pr-6">High employee activity in check-ins, feedback,
                      recognition, and core value alignment</div>
                  </div>
                </div>
                <div class="center" style="width: 30%;"><img :style="getImageAwardstyle('proactivity')"
                    :src="getImageAward('proactivity')" />
                  <div :style="getAwardTextStyle('proactivity')">
                    <div class="title fs-11 fw-600" style="margin-top: -16px;">Proactive Leadership</div>
                    <div class="description fs-11 mt-4 pl-6 pr-6">Managers excel in requesting peer feedback, replying
                      to team input, and completing timely reviews</div>
                  </div>
                </div>

              </div>



            </div>




          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
export default {
  name: "company-health-status",
  components: {
    loadingEven: require("./even/loading").default,
  },
  computed: {

    happyStatus() {
      return this.$store.getters["companyHealthStatus/happyStatus"];
    },
    happyStatuspercent() {

      return this.$store.getters["companyHealthStatus/happyStatuspercent"];
    },
    feedback() {

      return this.$store.getters["companyHealthStatus/feedback"];
    },
    managerRate() {
      return this.$store.getters["companyHealthStatus/managerRate"];
    },
    participationRate() {

      return this.$store.getters["companyHealthStatus/participationRate"];
    },
    award() {
      return this.$store.getters["companyHealthStatus/award"];
    },
    standardAward() {
      return this.$store.getters["companyHealthStatus/standardAward"];
    },
    percentileRank() {
      return this.$store.getters["companyHealthStatus/percentileRank"];
    },
    loading() {
      return this.$store.getters["companyHealthStatus/loading"];
    },
    loadingAward() {
      return this.$store.getters["companyHealthStatus/loadingAward"];
    },
    debi() {
      return this.$store.getters["companyHealthStatus/debi"];
    }
  },

  data() {
    return {
      activeName: "dashboard",
      anchor: {
        dashboard: "dashboard",
        teams: "teams",
        cohorts: "cohorts",
        managers: "managers",
        people: "people",
        report: "report",
      },
      renderComponent: true,
      company_name: '',
      //feedback:87,
      chartOptions: {
        responsive: true,
        plugins: {
          tooltip: false,
          title: {
            display: false,
          },
          legend: {
            display: false,
          },
        },
        interaction: {
          intersect: false,
        },
        elements: {
          point: {
            backgroundColor: "red",
          },
        },
        scales: {
          x: {
            display: true,
            grid: {
              display: false,
            },
            title: {
              display: false,
            },
          },
          y: {
            display: false,
          },
        },
      },
      myChart_feedback: null,
      myChart_participation: null,
      myChart_activity: null,
      styleImage: {
        NPS: '',
        eNPS: '',
        WHO_5: '',
        feedback: '',
        participation: '',
        debi: '',
        proactivity: ''
      }
    };
  },
  created() {
    let comp_id = ''
    let bytes = CryptoJS.AES.decrypt(
      this.$router.currentRoute.params.id,
      "company-health-status"
    );
    //console.log('bytes===',bytes)
    let originalText = bytes.toString(CryptoJS.enc.Utf8);
    if (originalText) {
      comp_id = originalText.split("||")[0];
      let name = originalText.split("||")[1];
      this.company_name = name
    }
    //this.$store.dispatch("companyHealthStatus/genlink");
    this.$store.dispatch("companyHealthStatus/login").then(() => {
      this.$store.dispatch("companyHealthStatus/getmostTopTeam", { comp_id: comp_id });
    });

  },

  methods: {

    arrayToPercentage(value) {
      const arr = [];
      if (value.length > 0) {
        for (let i in value) {

          let color = "bar-red";
          if (value[i].risk_percent >= 10) {
            color = "bar-red";
          } else if (value[i].happy_percent <= 70) {
            color = "bar-yellow";
          } else if (value[i].happy_percent > 70) {
            color = "bar-green";
          }
          arr.push(color);
        }

        return arr;

      } else {
        return arr;
      }

    },
    arrayToPercentage_ten(value, type) {
      const arr = [];
      const red = 0;
      let green = 70;
      let yellow = 35;
      if (type == 'feedback') {
        green = 40;
        yellow = 20;
      } else if (type == 'manager_activity') {
        green = 60;
        yellow = 30;
      }
      let color = "bar-red";
      if (value >= green) {
        color = "bar-green";
      } else if (value >= yellow) {
        color = "bar-yellow";
      }
      for (let i = 0; i < 10; i++) {
        let status = (value - i * 10) * 1;
        let style = "";
        if (status > 10) {
          style = "";
        } else if (value - i * 10 > 0) {
          style = `opa-0${status * 1}`;
        } else {
          color = "";
        }
        arr.push(`${style} ${color}`);
      }

      return arr;
    },
    getImageAwardstyle(type) {
      let award = this.award[type] ? this.award[type] : 0
      if (type == 'feedback') {
        award = this.feedback.openEndedFeedback
      } else if (type == 'participation') {
        award = this.participationRate.participationRate
      } else if (type == 'dbei') {
        award = this.debi.debi
      }
      if (award >= this.standardAward[type].ultra_platinum) {
        return 'width: 150px;height: 150px;'
      } else if (award >= this.standardAward[type].platinum) {
        return 'width: 150px;height: 150px;'
      } else if (award >= this.standardAward[type].gold) {
        return 'width: 150px;height: 150px;'
      } else {
        return 'width: 150px;height: 150px;opacity: 0.3;'
      }
    },
    getAwardTextStyle(type) {
      let award = this.award[type] ? this.award[type] : 0
      if (type == 'feedback') {
        award = this.feedback.openEndedFeedback
      } else if (type == 'participation') {
        award = this.participationRate.participationRate
      } else if (type == 'dbei') {
        award = this.debi.debi
      }
      if (award >= this.standardAward[type].ultra_platinum) {
        return ''
      } else if (award >= this.standardAward[type].platinum) {
        return ''
      } else if (award >= this.standardAward[type].gold) {
        return ''
      } else {
        return 'opacity: 0.5;'
      }
    },
    getImageAward(type) {
      let award = this.award[type] ? this.award[type] : 0
      if (type == 'feedback') {
        award = this.feedback.openEndedFeedback
      } else if (type == 'participation') {
        award = this.participationRate.participationRate
      } else if (type == 'dbei') {
        award = this.debi.debi
      }



      const imageName =
      {
        NPS: { gold: 'baa_gold', platinum: 'baa_platinum', ultra_platinum: 'baa_ultraplatinum' },
        eNPS: { gold: 'ess_gold', platinum: 'ess_platinum', ultra_platinum: 'ess_ultraplatinum' },
        WHO_5: { gold: 'ws_gold', platinum: 'ws_platinum', ultra_platinum: 'ws_ultraplatinum' },
        feedback: { gold: 'fc_gold', platinum: 'fc_platinum', ultra_platinum: 'fc_ultraplatinum' },
        participation: { gold: 'prp_gold', platinum: 'prp_platinum', ultra_platinum: 'prp_ultraplatinum' },
        debi: { gold: 'DEBI-Gold', platinum: 'DEBI-Platinum', ultra_platinum: 'DEBI-Ultra' },
        proactivity: { gold: 'Proactivity_Gold', platinum: 'Proactivity_Platinum', ultra_platinum: 'Proactivity_Ultra' }
      }

      this.styleImage[type] = ''
      if (award >= this.standardAward[type].ultra_platinum) {
        return require("@/assets/images/company-health-status/" + imageName[type].ultra_platinum + ".png");
      } else if (award >= this.standardAward[type].platinum) {
        return require("@/assets/images/company-health-status/" + imageName[type].platinum + ".png");
      } else if (award >= this.standardAward[type].gold) {
        return require("@/assets/images/company-health-status/" + imageName[type].gold + ".png");
      } else {
        this.styleImage[type] = 'opacity: 0.3;'
        return require("@/assets/images/company-health-status/" + imageName[type].gold + ".png");
      }
    },
    getCurve(value) {
      if (value > 75) {
        return require("@/assets/images/company-health-status/curve_4.png");
      } else if (value > 50) {
        return require("@/assets/images/company-health-status/curve_3.png");
      } else if (value > 25) {
        return require("@/assets/images/company-health-status/curve_2.png");
      } else {
        return require("@/assets/images/company-health-status/curve_1.png");
      }
    }
  },
};
</script>
<style scoped></style>
<style>
#company-health-status .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}

#company-health-status .el-tabs__header {
  margin: 0px;
}

#company-health-status .page-content {
  background: transparent linear-gradient(222deg, #5615EA 0%, #07BCA7 100%) 0% 0% no-repeat padding-box;
  opacity: 1;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}

.box {
  margin: 80px 0;
  width: 960px;
  /* UI Properties */
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 16px;
  opacity: 1;
  padding: 32px 46px 46px 46px;


}

.dot {
  height: 5px;
  width: 5px;
  margin-right: 8px;
  background-color: #6C30CC;
  border-radius: 50%;
  display: inline-block;
}

.box-shadow {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  -webkit-box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.008), 0px 0.8px 2.1px rgba(0, 0, 0, 0.012), 0px 1.5px 4px rgba(0, 0, 0, 0.015), 0px 2.7px 7.1px rgba(0, 0, 0, 0.018), 0px 5px 13.4px rgba(0, 0, 0, 0.022), 0px 12px 32px rgba(0, 0, 0, 0.03);
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.008), 0px 0.8px 2.1px rgba(0, 0, 0, 0.012), 0px 1.5px 4px rgba(0, 0, 0, 0.015), 0px 2.7px 7.1px rgba(0, 0, 0, 0.018), 0px 5px 13.4px rgba(0, 0, 0, 0.022), 0px 12px 32px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
}

.bar-contariner {


  .bar {
    border-radius: 6px;
    width: 7px;
    height: 24px;
    margin-right: 2px;
    background-color: #e5e5e5;
  }

  .bar-green {
    background-color: #35d077;
  }

  .bar-yellow {
    background-color: #fbc02d;
  }

  .bar-red {
    background-color: #f44336;
  }

  .bar-gray {
    background-color: #CCCCCC;
  }

}
</style>